import { Link, Route, Routes, useLocation } from "react-router-dom";
import CheckForm from "./components/CheckForm";
import AdminPage from "./components/AdminPage";

export default function App() {
  const location = useLocation();
  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="brand">
          需求文档智能检查
          <span className="version">v2026.01.16.3</span>
        </div>
        <nav className="nav">
          <Link
            className={location.pathname === "/" ? "nav-link active" : "nav-link"}
            to="/"
          >
            前台检查
          </Link>
          <Link
            className={
              location.pathname.startsWith("/admin") ? "nav-link active" : "nav-link"
            }
            to="/admin"
          >
            管理后台
          </Link>
        </nav>
      </header>
      <main className="app-main">
        <Routes>
          <Route path="/" element={<CheckForm />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </main>
    </div>
  );
}
